import { useState } from 'react';
import { CustomPaymentTypesApi } from '@/api/clients/custom-payments/custom-payment-types.api';

export const useToggleCustomPaymentType = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const toggleCustomPaymentType = async (
    organizationId,
    customPaymentTypeId,
  ) => {
    setLoading(true);
    setError(null);

    try {
      const response = await CustomPaymentTypesApi.toggleCustomPaymentType(
        organizationId,
        customPaymentTypeId,
      );
      return response.data?.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        'Failed to toggle custom payment type status';
      setError(errorMessage);
      console.error('Error toggling custom payment type status:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { toggleCustomPaymentType, loading, error };
};
